import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { themesMixin } from '../../../utils/themes';
import formMixin from '../formMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicApplicationsDetails',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [formMixin, themesMixin],
  props: {
    applicationObj: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      exportDialog: false,
      application: {},
      reportingMetics: {},
      packets: [],
      reportingPeriods: [{
        text: this.$i18n_t('NiotaClassic.Applications.details.oneDay'),
        value: '1d'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneWeek'),
        value: '1w'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.fourWeeks'),
        value: '4w'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneYear'),
        value: '48w'
      }],
      metricsSignal: {},
      selectedPeriod: {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneDay'),
        value: '1d'
      },
      reportingPeriodIndex: 0,
      isLoading: true,
      isLoadingMetrics: true,
      isLoadingHistoryMetrics: true,
      isLoadingCustomDevices: true,
      isLoadingDevicesBattery: true,
      isLoadingReportingMetics: true,
      isLoadingNotNominal: false,
      isLoadingSetDevicesBattery: false,
      isLoadingUnsetDevicesBattery: false,
      overviewPie: {},
      nominalDevicesPie: {},
      snrGraph: {},
      spreadingFactorGraph: {},
      dailyPacketsgraph: {},
      dailyPacketsgraphOptions: {},
      hourlyPacketsgraph: {},
      hourlyPacketsgraphOptions: {},
      customDevices: {},
      customDevicesResponse: {},
      spreadingFactorGraphOptions: {
        legend: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 7,
              max: 12,
              stepSize: 0.5
            }
          }]
        }
      },
      spreadingFactorAverage: 0,
      snrFullData: [],
      statistics: {},
      devicesBatteryGroups: {},
      devicesBatteryGroupsCount: {},
      devicesBatteryResponse: {},
      maxCardDevices: 50,
      notNominalDevicesList: [],
      setBatteryDevices: [],
      unsetBatteryDevices: [],
      websocketPackets: [],
      wsConnected: false,
      deviceFormDialog: false,
      deviceTypes: [],
      applications: [],
      editedDevice: null,
      hideMapTrigger: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'colorHexLight', 'colorHexDark'])),
  watch: {
    applicationObj: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.teardownWebSocket();
      this.setupN1WebSocket(this.applicationObj.id, get(this.applicationObj, 'account.data.realTimeApiKey'));
      this.getReportingMetrics(this.applicationObj.id, {
        range: this.selectedPeriod.value
      });
      this.getSignalMetrics(this.applicationObj.id);
      this.getFullMetrics(this.applicationObj.id);
      this.getCustomDevices(this.applicationObj.id);
      this.getDevicesBatteryStatus(this.applicationObj.id);
    }, 500),
    color: debounce(function () {
      set(this.overviewPie, 'color', this.vuetifyColorHex());
      set(this.nominalDevicesPie, 'color', this.vuetifyColorHex());
      set(this.hourlyPacketsgraph, 'individual[0].color', this.vuetifyColorHex());
      set(this.dailyPacketsgraph, 'individual[0].color', this.vuetifyColorHex());
      set(this.snrGraph, 'common.color', this.vuetifyColorHex());
      set(this.spreadingFactorGraph, 'color', this.vuetifyColorHex());
      this.updateDailyPacketsgraph();
      this.updateHourlyPacketsgraph();
    }, 500)
  },
  mounted: function mounted() {// this.getReportingMetrics(this.applicationObj.id, { range: '1d' });
  },
  destroyed: function destroyed() {
    this.teardownWebSocket();
  },
  created: function created() {
    this.application = cloneDeep(this.applicationObj);
  },
  methods: {
    getDeviceStatus: function getDeviceStatus(device) {
      var isNoOperationalStatusDeviceId = this.customDevicesResponse.noOperationalStatusDeviceIds.includes(device.id);
      var opStatusText = get(device, 'properties.operational_status.text');

      if (isNoOperationalStatusDeviceId || !opStatusText) {
        return this.$i18n_t('NiotaClassic.Applications.details.noStatus');
      }

      return "STATUS: ".concat(opStatusText);
    },
    openLink: function openLink() {
      window.open(this.applicationObj.url);
    },
    getReportingMetrics: function getReportingMetrics(id, reportingData) {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      this.isLoadingReportingMetics = true;
      return NiotaClassicApiService.getApplicationMetricsReporting(id, reportingData).then(function (res) {
        _this.reportingMetics = res.data;
        _this.notNominalDevicesList = _this.reportingMetics.notNominalDevices;

        _this.updateOverviewPie();

        _this.updateNominalDevicesPie();
      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this.isFetching = false;
        _this.isLoadingReportingMetics = false;
      });
    },
    setReportingPeriod: function setReportingPeriod(periodIndex) {
      this.ReportingPeriod = periodIndex;
      this.selectedPeriod = this.reportingPeriods[periodIndex];
      this.getReportingMetrics(this.applicationObj.id, {
        range: this.selectedPeriod.value
      });
    },
    updateOverviewPie: function updateOverviewPie() {
      var onlineDevicesPercent = this.reportingMetics.devicesOnlineInPercent;
      var offlineDevicesPercent = this.reportingMetics.devicesOfflineInPercent;
      var onlineDevices = this.reportingMetics.devicesOnlineCount;
      var offlineDevices = this.reportingMetics.devicesOfflineCount;
      this.overviewPie = {
        data: [onlineDevices, offlineDevices],
        color: this.vuetifyColorHex(),
        labels: ["Online (".concat(onlineDevicesPercent, "%)"), "Offline (".concat(offlineDevicesPercent, "%)")]
      };
    },
    updateNominalDevicesPie: function updateNominalDevicesPie() {
      var nomPercent = this.reportingMetics.nominalInPercent;
      var notNomDPercent = this.reportingMetics.notNominalInPercent;
      var nominalPercent = this.reportingMetics.nominalDevicesCount;
      var notNominalDPercent = this.reportingMetics.notNominalDevicesCount;
      this.nominalDevicesPie = {
        data: [nominalPercent, notNominalDPercent],
        color: this.vuetifyColorHex(),
        labels: ["Nominal (".concat(nomPercent, "%)"), "Non-Nominal (".concat(notNomDPercent, "%)")]
      };
    },
    getSignalMetrics: function getSignalMetrics(id) {
      var _this2 = this;

      if (this.isFetchingMetrics) {
        return;
      }

      this.isFetchingMetrics = true;
      this.isLoadingMetrics = true;
      return NiotaClassicApiService.getApplicationMetricsSignal(id).then(function (res) {
        _this2.metricsSignal = res.data;
        _this2.snrFullData = _this2.metricsSignal.snr; // this.updateSNRgraph();
      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this2.isFetchingMetrics = false;
        _this2.isLoadingMetrics = false;
      });
    },
    getFullMetrics: function getFullMetrics(id) {
      var _this3 = this;

      if (this.isFetchingHistoryMetrics) {
        return;
      }

      this.isFetchingHistoryMetrics = true;
      this.isLoadingHistoryMetrics = true;
      return NiotaClassicApiService.getApplicationMetricsHistory(id).then(function (res) {
        _this3.fullMetrics = res.metrics;
        _this3.statistics = res.metrics.statistics || {
          invalid: true
        }; // this.snrFullData = this.metricsSignal.snr;

        _this3.updateSNRgraph();

        _this3.updateDailyPacketsgraph();

        _this3.updateHourlyPacketsgraph();
      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this3.isFetchingHistoryMetrics = false;
        _this3.isLoadingHistoryMetrics = false;
      });
    },
    updateSNRgraph: function updateSNRgraph() {
      if ((get(this.fullMetrics, 'signal.snr') || []).length === 0) {
        return;
      }

      var labels = this.fullMetrics.signal.snr.map(function (k) {
        var date = new Date(k.time);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        return "".concat(day, ".").concat(month);
      });
      var snrData = this.fullMetrics.signal.snr.map(function (k) {
        return k.value;
      });
      var rssiData = this.fullMetrics.signal.rssi.map(function (k) {
        return k.value;
      });
      var spreadingFactorData = this.fullMetrics.signal.spreading_factor.data.map(function (k) {
        return k.value;
      });
      this.spreadingFactorAverage = this.fullMetrics.signal.spreading_factor.average;
      this.spreadingFactorGraph = {
        data: spreadingFactorData,
        label: 'SF',
        color: this.vuetifyColorHex(),
        dataLabels: labels
      };
      this.snrGraph = {
        common: {
          color: this.vuetifyColorHex(),
          labels: labels
        },
        individual: [{
          data: snrData,
          label: 'SNR'
        }, {
          data: rssiData,
          label: 'RSSI'
        }]
      };
    },
    updateDailyPacketsgraph: function updateDailyPacketsgraph() {
      if ((get(this.fullMetrics, 'daily') || []).length === 0) {
        this.dailyPacketsgraph = {
          common: {
            color: false,
            labels: []
          },
          individual: [{
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.latest'),
            color: this.vuetifyColorHex()
          }, {
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.previous'),
            color: '#c2c2c2'
          }]
        };
        return;
      }

      var labels = this.fullMetrics.daily.map(function (k) {
        var date = new Date(k.date);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        return "".concat(day, ".").concat(month);
      });
      var dailyData = this.fullMetrics.daily.map(function (k) {
        return k.value;
      });
      var previousDailyData = this.fullMetrics.daily_previous_Period.map(function (k) {
        return k.value;
      });
      this.dailyPacketsgraph = {
        common: {
          color: false,
          labels: labels
        },
        individual: [{
          data: dailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.latest'),
          color: this.vuetifyColorHex()
        }, {
          data: previousDailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.previous'),
          color: '#c2c2c2'
        }]
      }; // To only show the main chart and not show the packets from yesterday

      if (!this.showOrHideDetails('statistics')) {
        this.dailyPacketsgraph = get(this.dailyPacketsgraph, 'individual[0]');
        set(this.dailyPacketsgraph, 'dataLabels', labels);
      }

      if (!this.statistics.invalid) {
        this.dailyPacketsgraphOptions.max = this.statistics.custom_period_previous.max > this.statistics.custom_period.max ? this.statistics.custom_period_previous.max : this.statistics.custom_period.max;
        this.dailyPacketsgraphOptions.annotations = [];

        if (this.statistics.custom_period.average) {
          this.dailyPacketsgraphOptions.annotations.push({
            value: this.statistics.custom_period.average,
            label: "".concat(this.$i18n_t('NiotaClassic.Applications.details.Average'), " (").concat(this.statistics.custom_period.average.toFixed(2), "/d)"),
            labelPadding: -150
          });
        }

        if (this.statistics.custom_period_previous.average) {
          this.dailyPacketsgraphOptions.annotations.push({
            value: this.statistics.custom_period_previous.average,
            label: "".concat(this.$i18n_t('NiotaClassic.Applications.details.PreviousAverage'), " (").concat(this.statistics.custom_period_previous.average.toFixed(2), "/d)"),
            labelPadding: 150
          });
        }
      }
    },
    updateHourlyPacketsgraph: function updateHourlyPacketsgraph() {
      if ((get(this.fullMetrics, 'hourly') || []).length === 0) {
        this.hourlyPacketsgraph = {
          common: {
            color: false,
            labels: []
          },
          individual: [{
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.receivedLast24Hour'),
            color: this.vuetifyColorHex()
          }, {
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.fromYesterday'),
            color: '#c2c2c2'
          }]
        };
        return;
      }

      var labels = this.fullMetrics.hourly.map(function (k) {
        k.date = new Date(k.date);
        var hours = "0".concat(k.date.getHours()).slice(-2);
        return "".concat(hours, ":00");
      });
      var dailyData = this.fullMetrics.hourly.map(function (k) {
        return k.value;
      });
      var previousDailyData = this.fullMetrics.hourly_yesterday.map(function (k) {
        return k.value;
      });
      this.hourlyPacketsgraph = {
        common: {
          color: false,
          labels: labels
        },
        individual: [{
          data: dailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.receivedLast24Hour'),
          color: this.vuetifyColorHex()
        }, {
          data: previousDailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.fromYesterday'),
          color: '#c2c2c2'
        }]
      };

      if (!this.statistics.invalid) {
        this.hourlyPacketsgraphOptions.max = this.statistics.daily_yesterday.max > this.statistics.daily.max ? this.statistics.daily_yesterday.max : this.statistics.daily.max;
        this.hourlyPacketsgraphOptions.annotations = [];

        if (this.statistics.daily.average) {
          this.hourlyPacketsgraphOptions.annotations.push({
            value: this.statistics.daily.average,
            label: "".concat(this.$i18n_t('NiotaClassic.Applications.details.Average24hr'), " (").concat(this.statistics.daily.average.toFixed(2), "/d)"),
            labelPadding: -150
          });
        }

        if (this.statistics.daily_yesterday.average) {
          this.hourlyPacketsgraphOptions.annotations.push({
            value: this.statistics.daily_yesterday.average,
            label: "".concat(this.$i18n_t('NiotaClassic.Applications.details.AverageYesterday'), " (").concat(this.statistics.daily_yesterday.average.toFixed(2), "/d)"),
            labelPadding: 150
          });
        }
      } // To only show the main chart and not show the packets from yesterday


      if (!this.showOrHideDetails('statistics')) {
        this.hourlyPacketsgraph = get(this.hourlyPacketsgraph, 'individual[0]');
        set(this.hourlyPacketsgraph, 'dataLabels', labels);
      }
    },
    getCustomDevices: function getCustomDevices(id) {
      var _this4 = this;

      if (this.isFetchingCustomDevices) {
        return;
      }

      this.isFetchingCustomDevices = true;
      this.isLoadingCustomDevices = true;
      return NiotaClassicApiService.getApplicationCustomDevices(id).then(function (res) {
        _this4.customDevicesResponse = res.data;
        _this4.customDevices = res.data.devices;

        _this4.setCustomDevicesColor(); // this.snrFullData = this.metricsSignal.snr;
        // this.updateSNRgraph();

      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this4.isFetchingCustomDevices = false;
        _this4.isLoadingCustomDevices = false;
      });
    },
    filterDevices: function filterDevices(group) {
      var _this5 = this;

      var deviceIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      switch (group) {
        case 'notNominal':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingNotNominal = true;
              return NiotaClassicApiService.getApplicationFilteredDevices(this.applicationObj.id, {
                deviceIds: deviceIds
              }).then(function (res) {
                _this5.notNominalDevicesList = res.data.devices;
              }).catch(function (error) {
                console.error('Error:', error);
              }).finally(function () {
                _this5.isLoadingNotNominal = false;
              });
            } else {
              this.notNominalDevicesList = [];
            }
          } else {
            this.notNominalDevicesList = this.reportingMetics.notNominalDevices;
          }

          break;

        case 'operational':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingCustomDevices = true;
              return NiotaClassicApiService.getApplicationFilteredDevices(this.applicationObj.id, {
                deviceIds: deviceIds
              }).then(function (res) {
                _this5.customDevices = res.data.devices;

                _this5.setCustomDevicesColor();
              }).catch(function (error) {
                console.error('Error:', error);
              }).finally(function () {
                _this5.isLoadingCustomDevices = false;
              });
            } else {
              this.customDevices = [];
            }
          } else {
            this.customDevices = this.customDevicesResponse.devices;
          }

          break;

        case 'unsetBattery':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingUnsetDevicesBattery = true;
              return NiotaClassicApiService.getBatteryLevelFilteredDevices(this.applicationObj.id, {
                deviceIds: deviceIds
              }).then(function (res) {
                _this5.unsetBatteryDevices = res.unsetDevices;

                _this5.setunsetDevicesColor();
              }).catch(function (error) {
                console.error('Error:', error);
              }).finally(function () {
                _this5.isLoadingUnsetDevicesBattery = false;
              });
            } else {
              this.unsetBatteryDevices = [];
            }
          } else {
            this.unsetBatteryDevices = this.devicesBatteryGroups.unsetDevices;
          }

          break;

        case 'setBattery':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingSetDevicesBattery = true;
              return NiotaClassicApiService.getBatteryLevelFilteredDevices(this.applicationObj.id, {
                deviceIds: deviceIds
              }).then(function (res) {
                _this5.setBatteryDevices = res.allBatteryAlerts;

                _this5.setDevicesBatteryLvlColor();
              }).catch(function (error) {
                console.error('Error:', error);
              }).finally(function () {
                _this5.isLoadingSetDevicesBattery = false;
              });
            } else {
              this.setBatteryDevices = [];
            }
          } else {
            this.setBatteryDevices = this.devicesBatteryResponse.allBatteryAlerts;
          }

      }
    },
    filterCustomDevices: function filterCustomDevices() {
      var _this6 = this;

      var statusType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'any';

      switch (statusType) {
        case 'operational':
          return this.customDevices.filter(function (device) {
            _this6.customDevicesResponse.inOperationDeviceIds.includes(device.id);
          });

        case 'nonOperational':
          return this.customDevices.filter(function (device) {
            _this6.customDevicesResponse.notOperationalDeviceIds.includes(device.id);
          });

        case 'noStatus':
          return this.customDevices.filter(function (device) {
            _this6.customDevicesResponse.noOperationalStatusDeviceIds.includes(device.id);
          });

        default:
          return this.customDevices;
      }
    },
    setCustomDevicesColor: function setCustomDevicesColor() {
      var _this7 = this;

      this.customDevicesResponse.inOperationDeviceIds.forEach(function (deviceId) {
        _this7.customDevices.filter(function (customDevice) {
          return customDevice.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'green';
        });
      });
      this.customDevicesResponse.notOperationalDeviceIds.forEach(function (deviceId) {
        _this7.customDevices.filter(function (customDevice) {
          return customDevice.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'red';
        });
      });
      this.customDevicesResponse.noOperationalStatusDeviceIds.forEach(function (deviceId) {
        _this7.customDevices.filter(function (customDevice) {
          return customDevice.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'orange';
        });
      });
    },
    setunsetDevicesColor: function setunsetDevicesColor() {
      var _this8 = this;

      this.devicesBatteryResponse.withoutTypeDeviceIds.forEach(function (deviceId) {
        _this8.unsetBatteryDevices.filter(function (device) {
          return device.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'red';
        });
      });
      this.devicesBatteryResponse.withoutLevelDeviceIds.forEach(function (deviceId) {
        _this8.unsetBatteryDevices.filter(function (device) {
          return device.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'orange';
        });
      });
    },
    setDevicesBatteryLvlColor: function setDevicesBatteryLvlColor() {
      var _this9 = this;

      this.devicesBatteryResponse.alertDeviceIds.forEach(function (deviceId) {
        _this9.setBatteryDevices.filter(function (device) {
          return device.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'red';
        });
      });
      this.devicesBatteryResponse.warningDeviceIds.forEach(function (deviceId) {
        _this9.setBatteryDevices.filter(function (device) {
          return device.id === deviceId;
        }).forEach(function (device) {
          return device.textColor = 'orange';
        });
      });
    },
    getDevicesBatteryStatus: function getDevicesBatteryStatus(id) {
      var _this10 = this;

      if (this.isFetchingDevicesBattery) {
        return;
      }

      this.isFetchingDevicesBattery = true;
      this.isLoadingDevicesBattery = true;
      return NiotaClassicApiService.getApplicationDevicesBatteryStatus(id).then(function (res) {
        _this10.devicesBatteryResponse = res;
        _this10.devicesBatteryGroups = res.devices_groups;
        _this10.unsetBatteryDevices = _this10.devicesBatteryGroups.unsetDevices;
        _this10.setBatteryDevices = _this10.devicesBatteryResponse.allBatteryAlerts;
        _this10.devicesBatteryGroupsCount = res.devices_groups_count;
        _this10.devicesBatteryStatus = res.devices;

        _this10.setunsetDevicesColor();

        _this10.setDevicesBatteryLvlColor();
      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this10.isFetchingDevicesBattery = false;
        _this10.isLoadingDevicesBattery = false;
      });
    },
    filterDevicesBattery: function filterDevicesBattery() {
      var _this11 = this;

      var statusType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'any';

      switch (statusType) {
        case 'unset':
          return this.devicesBatteryStatus.filter(function (device) {
            _this11.devicesBatteryResponse.withoutTypeDeviceIds.includes(device.id);
          });

        case 'withoutDeviceType':
          return this.devicesBatteryStatus.filter(function (device) {
            _this11.devicesBatteryResponse.withoutTypeDeviceIds.includes(device.id);
          });

        case 'withoutBatteryLevel':
          return this.devicesBatteryStatus.filter(function (device) {
            _this11.devicesBatteryResponse.withoutLevelDeviceIds.includes(device.id);
          });

        case 'warning':
          return this.devicesBatteryStatus.filter(function (device) {
            _this11.devicesBatteryResponse.warningDeviceIds.includes(device.id);
          });

        case 'alert':
          return this.devicesBatteryStatus.filter(function (device) {
            _this11.devicesBatteryResponse.alertDeviceIds.includes(device.id);
          });

        default:
          return this.customDevices;
      }
    },
    setupN1WebSocket: function setupN1WebSocket(id, key) {
      if (key) {
        this.lclObjectStr = 'Establishing connection\n';
        this.connection = new WebSocket("ws".concat(this.n1Protocol === 'https' ? 's' : '', "://").concat(this.n1Host, "/api/x/websocket/applications/").concat(id, "?auth=").concat(key));
        var instance = this;

        this.connection.onmessage = function (event) {
          instance.lclObjectStr += "Data-Packet START:\n".concat(event.data, "\nData-Packet END\n"); // console.log('WS-Data:', { data: event.data });

          instance.websocketPackets.unshift(JSON.parse(event.data));
        };

        this.connection.onopen = function () {
          // console.log('WS: Connected');
          instance.lclObjectStr += 'Successfully connected to the websocket server\nWaiting for data...\n';
          instance.wsConnected = true;
        };

        this.connection.onerror = function (error) {
          instance.lclObjectStr += "An error occurred: ".concat(error, "\n");
        };

        this.connection.onclose = function () {
          instance.lclObjectStr += 'Disconnected from WebSocket Server\n';
        };
      } else {
        console.error('WS: No API key for this application');
      }
    },
    teardownWebSocket: function teardownWebSocket() {
      if (this.connection) {
        this.connection.close();
      }
    },
    viewDevice: function viewDevice(deviceId) {
      this.$router.push({
        path: "/niota-classic/devices/".concat(deviceId, "/details")
      });
    },
    editDevice: function () {
      var _editDevice = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.deviceTypes.length && !this.applications.length)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.deviceTypeFetchPlain();

              case 3:
                _context.next = 5;
                return this.applicationsFetchPlain();

              case 5:
                _context.next = 7;
                return this.fetchDeviceDetails(deviceId);

              case 7:
                this.deviceFormDialog = true;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editDevice(_x) {
        return _editDevice.apply(this, arguments);
      }

      return editDevice;
    }(),
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this12 = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this12.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this12.deviceTypes = [];

        _this12.$snack(_this12.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain: function applicationsFetchPlain() {
      var _this13 = this;

      NiotaClassicApiService.applicationsFetchPlain().then(function (res) {
        _this13.applications = res.data.applications;
      }).catch(function () {
        _this13.applications = [];

        _this13.$snack(_this13.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
      });
    },
    fetchDeviceDetails: function fetchDeviceDetails(deviceId) {
      var _this14 = this;

      NiotaClassicApiService.deviceGetDetails(deviceId).then(function (res) {
        _this14.editedDevice = res.data.device;
      }).catch(function () {
        _this14.editedDevice = null;

        _this14.$snack(_this14.$i18n_t('NiotaClassic.Applications.snacks.deviceNotFound'), 'error');
      });
    },
    showOrHideDetails: function showOrHideDetails() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFgraph';
      return this.applicationObj && get(this.applicationObj, "properties.detailsViewCards.".concat(property));
    },
    hideMap: function hideMap(hide) {
      this.hideMapTrigger = hide;
    }
  }
};